import './counter-signature-module-screen.scss'

import { PropType } from "vue";
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { faArrowLeft, faCheck, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import { CounterSignatureResource, CounterSignerResource, createTranslatedString, editTranslatedString, getTranslatedString } from "@skinsoft/types";

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC, COUNTER_SIGNATURE_UPDATED, COUNTER_SIGNER_UPDATED, REMOVE_COUNTER_SIGNATURE, REMOVE_COUNTER_SIGNER, SAVE_CONTRE_SIGNED_REPORT, SIGNATURE_UPDATED } from "../../../../busTopics";
import { CounterSignature } from "../../../report-edition/summary-area/counter-signatures/counter-signature";
import { CounterSigner } from '../../../report-edition/summary-area/counter-signatures/counter-signature/counter-signer';
import { SigningArea } from '../signing-area';

@Component({
    components: {
        sCounterSignature: CounterSignature,
        sCounterSigner: CounterSigner,
        sSigningArea: SigningArea,
    },
    props: {
        counterSignature: {
            type: Object as PropType<CounterSignatureResource>
        }
    },
    template: require('./counter-signature-module-screen.html')
})
export class CounterSignatureModuleScreen extends ReactiveVue {

    public counterSignature: CounterSignatureResource
    private updatedCounterSignature: CounterSignatureResource = {}
    private lastSignerId: number = 1
    private showSaveWarning: boolean = false
    private showExitWarning: boolean = false

    private plusIcon = faPlusCircle
    private saveIcon = faCheck
    private backIcon = faArrowLeft

    private SIGNATURE_UPDATED = SIGNATURE_UPDATED
    private COUNTER_SIGNATURE_UPDATED = COUNTER_SIGNATURE_UPDATED
    private REMOVE_COUNTER_SIGNER = REMOVE_COUNTER_SIGNER
    private COUNTER_SIGNER_UPDATED = COUNTER_SIGNER_UPDATED

    refs: {
        anchor: HTMLDivElement
    }

    mounted() {
        this.cloneCounterSignature()
    }


    public get reason(): string {
        return getTranslatedString(this.updatedCounterSignature.reason, this.$i18n.locale)
    }

    public get comment(): string {
        return getTranslatedString(this.updatedCounterSignature.comment, this.$i18n.locale)
    }

    public get location(): string {
        return getTranslatedString(this.updatedCounterSignature.location, this.$i18n.locale)
    }

    public getSignature(arrayIndex: number): string {
        if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
            const signer = this.updatedCounterSignature.observationCarriedPresenceOfs[arrayIndex]
            if(signer && signer.signature) {
                return signer.signature
            }
        }
        return ''
    }

    private onCounterSignatureUpdated(updatedSignature: CounterSignatureResource) {
        this.updatedCounterSignature = updatedSignature
    }

    private onSignatureUpdated(signature: string, index: number) {
        if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
            const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
                return signer.index === index
            })
            if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
                let updatedSigner = this.updatedCounterSignature.observationCarriedPresenceOfs[signerIndexInArray]
                if(updatedSigner.signature) {
                    updatedSigner.signature = signature
                } else {
                    _.set(updatedSigner, 'signature', signature)
                }
                this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1, updatedSigner)
            }
        }
    }

    private onAddSigner() {
        const blankSigner: CounterSignerResource = {
            index: this.lastSignerId,
            surnameFirstName: createTranslatedString(this.$i18n.locale, ""),
            function: undefined,
            signature: undefined,
        }
        this.lastSignerId++

        if(this.updatedCounterSignature.observationCarriedPresenceOfs) {
            this.updatedCounterSignature.observationCarriedPresenceOfs.push(blankSigner)
        } else {
            _.set(this.updatedCounterSignature, 'observationCarriedPresenceOfs', [blankSigner])
        }
    }

    private onDeleteCounterSigner(index: number) {
        const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
            return signer.index === index
        })
        if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
            this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1)
        }
    }

    private onCounterSignerUpdated(updatedSigner: CounterSignerResource, index: number) {
        const signerIndexInArray = this.updatedCounterSignature.observationCarriedPresenceOfs?.findIndex(signer => {
            return signer.index === index
        })
        if(signerIndexInArray !== undefined && signerIndexInArray > -1) {
            this.updatedCounterSignature.observationCarriedPresenceOfs?.splice(signerIndexInArray, 1, updatedSigner)
        }
    }

    private warnBeforeSave() {
        this.showSaveWarning = true
        this.showExitWarning = false
        this.goToTopOfPage()
    }

    private warnBeforeCloseSignatureModule() {
        this.showExitWarning = true
        this.showSaveWarning = false
        this.goToTopOfPage()    
    }

    private dismissWarning() {
        this.showSaveWarning = false
        this.showExitWarning = false
    }

    private save() {
        this.$emit(SAVE_CONTRE_SIGNED_REPORT, [this.updatedCounterSignature, this.counterSignature.index])
        this.emitOnBus(CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC)
    }

    private closeSignatureModule() {
        this.$emit(REMOVE_COUNTER_SIGNATURE, this.counterSignature.index)
        this.emitOnBus(CLOSE_COUNTER_SIGNATURE_MODULE_TOPIC)
    }

    private cloneCounterSignature() {
        this.updatedCounterSignature = _.cloneDeep(this.counterSignature)
        if(this.updatedCounterSignature.observationCarriedPresenceOfs?.length) {
            this.lastSignerId = this.updatedCounterSignature.observationCarriedPresenceOfs[length].index ?? 1
        }
    }

    private goToTopOfPage() {
        if((this.$refs.anchor as Element).scrollIntoView ) {
            (this.$refs.anchor as Element).scrollIntoView({ 
                behavior: "smooth", 
                block: "start", 
            })
        }
    }

    @Watch('counterSignature')
    onCounterSignatureChanged() {
        this.cloneCounterSignature()
    }
}